import { DEFAULT_PAGE_SIZE } from '@shared/constants'
import { useLocales } from '@shared/locales'
import { defaultFilters } from '@shared/utils'
import { TablePaginationConfig } from 'antd'
import { PaginationConfig } from 'antd/es/pagination'
import { useState } from 'react'

import { useQueryParams } from './useQueryParams'

export type PaginationTypes<T> = {
  count?: number
  next?: string | null | number
  previous?: string | null | number
  current_page?: number
  total_pages?: number
  per_page?: number
  results?: T
}

export const defaultPageSizeOptions = ['10', '20', '50', '100']

export const usePaginationConfig = (
  list?: PaginationTypes<unknown>,
  showSizeChanger = false
): TablePaginationConfig => {
  const { t } = useLocales()
  const params = useQueryParams()

  const defaultPageSize = list?.per_page || defaultFilters?.perPage

  return {
    position: ['bottomCenter'],
    total: list?.count,
    pageSize: showSizeChanger ? params.pageSize : defaultPageSize,
    current: list?.current_page || params.page || defaultFilters.page,
    showTotal: (total) => `${t('total')} ${total} ${t('items')}`,
    showSizeChanger,
    pageSizeOptions: defaultPageSizeOptions,
    locale: { items_per_page: '' },
    hideOnSinglePage: true
  }
}

export const usePaginationListConfig = (
  list?: PaginationTypes<unknown>
): PaginationConfig => {
  return {
    total: list?.count,
    pageSize: list?.per_page,
    current: list?.current_page,
    pageSizeOptions: defaultPageSizeOptions
  }
}

export const usePagination = (): TablePaginationConfig => {
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
  const [page, setPage] = useState(1)

  const onChange = (page: number) => setPage(page)

  const onShowSizeChange = (_: number, size: number) => setPageSize(size)

  return {
    current: page,
    pageSize,
    onChange,
    onShowSizeChange,
    position: ['bottomCenter'],
    hideOnSinglePage: true
  }
}
